import axios from "axios";
import { urlCoreBack } from "../configs/config";
import '../utils/axios.interceptor';
import { format } from "date-fns";

const epName = "v1/cristal-valor/";
const nameItemsText = "Valores de Cristal";
const nameItemText = "Valor de Cristal";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getCristalesValor = async (params) => {
  let _params = {};
  let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

  if (params) {
    if (params.idProveedor) {
      _params.id_proveedor = params.idProveedor;
    }

    if (params.idCristalProducto) {
      _params.id_cristal_producto = params.idCristalProducto;
    }

    if (params.idBlCrDiametro) {
      _params.id_bl_cr_diametro = params.idBlCrDiametro;
    }

    if (params.idBlCrAdicionDesde) {
      _params.id_bl_cr_adicion_desde = params.idBlCrAdicionDesde;
    }

    if (params.idBlCrAdicionHasta) {
      _params.id_bl_cr_adicion_hasta = params.idBlCrAdicionHasta;
    }

    if (params.esferaDesde) {
      _params.esfera_desde = params.esferaDesde
    }

    if (params.esferaHasta) {
      _params.esfera_hasta = params.esferaHasta;
    }

    if (params.cilindroDesde) {
      _params.cilindro_desde = params.cilindroDesde
    }

    if (params.cilindroHasta) {
      _params.cilindro_hasta = params.cilindroHasta;
    }

    if (params.costoRealDesde) {
      _params.costo_real_desde = params.costoRealDesde
    }

    if (params.costoRealHasta) {
      _params.costo_real_hasta = params.costoRealHasta;
    }

    if (params.fechaCostoRealDesde) {
      _params.fecha_costo_real_desde = format(params.fechaCostoRealDesde, "yyyy/MM/dd");
    }

    if (params.fechaCostoRealHasta) {
      _params.fecha_costo_real_hasta = format(params.fechaCostoRealHasta, "yyyy/MM/dd");
    }

    if (params.listaDeReferencia) {
      if (params.listaDeReferencia === "todos") {
        _params.referencia = "T";
      } else if (params.listaDeReferencia === "solo-referencia") {
        _params.referencia = "S";
      } else if (params.listaDeReferencia === "solo-no-referencia") {
        _params.referencia = "N";
      }
    }
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);
        let _message_code = response.data.code;
        if (_message_code === "err-cristal-valor-cilindro-invalid") {
          response.messageText = "Valor de Cilindro no válido. (desde -10 hasta 10 y mod 25)";
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getCristalValor = async (params) => {
  let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveCristalValor = async (items) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;
  try {
    const response = await axios({
      method: "PUT",
      url: `${urlCoreBack}${epName}`,
      data: {
        rango_list: items,
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Valores actualizados";
        response.messageSeverity = "success";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;

  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

